import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzK9BlBg } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_BL_BG: Record<
  PageIdWoofzK9BlBg,
  TPageConfig
> = {
  [PageIdWoofzK9BlBg.DOG_AGE_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOG_AGE_K9_BL_BG,
    hasHeader: true,
  },
  [PageIdWoofzK9BlBg.DOG_SEX_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOG_SEX_K9_BL_BG,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.DOG_BREED_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOG_BREED_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.DOG_BREED_ID_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOG_BREED_ID_K9_BL_BG,
  },
  [PageIdWoofzK9BlBg.URGE_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.URGE_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.CHALLENGES_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.CHALLENGES_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.URGE_1_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.URGE_1_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.LEASH_PULLING_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.LEASH_PULLING_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.URGE_LEASH_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.URGE_LEASH_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.DURING_WALK_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DURING_WALK_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.URGE_NOT_ALONE_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.URGE_NOT_ALONE_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.AGRESSIVE_BEHAVIOR_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.AGRESSIVE_BEHAVIOR_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.TRIGGERS_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.TRIGGERS_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.URGE_2_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.URGE_2_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.BEHAVIOR_ISSUES_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.BEHAVIOR_ISSUES_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.DOG_ACT_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOG_ACT_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.DOG_OFF_AT_HOME_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOG_OFF_AT_HOME_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.REWARDS_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.REWARDS_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.IGNORE_COMMANDS_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.IGNORE_COMMANDS_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9BlBg.COMMANDS_61_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.COMMANDS_61_K9_BL_BG,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.COMMANDS_62_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.COMMANDS_62_K9_BL_BG,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.COMMANDS_63_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.COMMANDS_63_K9_BL_BG,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.URGE_3_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.URGE_3_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.PREPARE_SCREEN_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.PREPARE_SCREEN_K9_BL_BG,
    hasHeader: true,
  },
  [PageIdWoofzK9BlBg.DOG_PROFILE_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOG_PROFILE_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.URGE_REVIEWED_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.URGE_REVIEWED_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.PREPARE_FLOW_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.PREPARE_FLOW_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.EMAIL_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.EMAIL_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.NEWSLETTER_URGE_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.NEWSLETTER_URGE_K9_BL_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9BlBg.SCRATCH_SCREEN_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.SCRATCH_SCREEN_K9_BL_BG,
    hasHeader: true,
  },
  [PageIdWoofzK9BlBg.SUBSCRIPTIONS_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.SUBSCRIPTIONS_K9_BL_BG,
  },
  [PageIdWoofzK9BlBg.CHAT_UPSELL_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.CHAT_UPSELL_K9_BL_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9BlBg.UPSELL_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.UPSELL_K9_BL_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9BlBg.UPSELL_FEEDING_GUIDE_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.UPSELL_FEEDING_GUIDE_K9_BL_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9BlBg.UPSELL_EMOTIONAL_SUPPORT_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.UPSELL_EMOTIONAL_SUPPORT_K9_BL_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9BlBg.DOWNLOAD_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.DOWNLOAD_K9_BL_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9BlBg.ACCOUNT_K9_BL_BG]: {
    id: PageIdWoofzK9BlBg.ACCOUNT_K9_BL_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
